<template>
  <div>
      <InfoUser @changeActiveCard='data=> emitToParent("changeActiveCard",this,data)' @userData='data => emitToParent("userData",this,data)' v-bind="userData"/>
      <FilterList :giroCard="giroCardNumber" :userExtrato="userExtrato" @returnExtrato='setExtrato'/>
      <ModalNovosTermos/>
  </div>
</template>

<style lang="scss">
 @import "../assets/scss/extrato.scss";
</style>

<script>
import InfoUser from '@/components/InfoUser.vue'
import FilterList from '@/components/FilterList.vue'
import {emitToParent,scrollTop, redirect} from '../helpers/helpers'
// import {get} from '../services/image.service'
import ModalNovosTermos from '@/components/ModalNovosTermos.vue'

export default {
  name: 'extrato',
  data(){
    return{
      userExtrato:null,
      giroCardNumber:null
    }
  },
  components: {
      InfoUser,
      FilterList,
      ModalNovosTermos
  },
  props:{
    userData:{
      type:Object
    }
  },
  methods:{
    emitToParent,
    setExtrato(extrato){
      this.userExtrato = extrato.filter(v => v.OPERATION == 'DEBITO' || v.OPERATION == 'CREDITO' || v.OPERATION == 'CASHBACK')
    }
  }, 
  created(){
    const {userData} = this
    if(!sessionStorage.getItem("giro-token")) redirect("login",this)
    if(userData && userData.activeCard) this.giroCardNumber = userData.activeCard.cardNumber
    //emitToParent("getImage",this,"Extrato")
    scrollTop()
    
  }
}
</script>
